/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CommonLoading } from '../../../../../Utils/commonLoading'

type Props = {
  isLoading: boolean
  data: any[]
  tableRef: any
}

/**
 * Table component specifically for Uninvoiced Calls
 * Shows only the required 14 columns:
 * Call ID, Appointment ID, Interpreter, Customer, Requester, Date, Start Time, End Time,
 * Total Duration, Language To, Communication Type, Appointment Status, Call Status, Meeting Summary Status
 */
const UninvoicedCallsTable: React.FC<Props> = ({ isLoading, data, tableRef }) => {
  const navigate = useNavigate()

  return (
    <div className='table-responsive'>
      <table
        ref={tableRef}
        className='table table-row-dashed table-row-gray-300 align-middle gs-3 gy-3'
      >
        <thead>
          <tr className='fw-semibold text-muted text-uppercase'>
            <th className='min-w-150px'>Call ID</th>
            <th className='min-w-150px'>Appointment ID</th>
            <th className='min-w-150px'>Interpreter</th>
            <th className='min-w-150px'>Customer</th>
            <th className='min-w-150px'>Requester</th>
            <th className='min-w-120px'>Date</th>
            <th className='min-w-100px'>Start Time</th>
            <th className='min-w-100px'>End Time</th>
            <th className='min-w-120px'>Total Duration</th>
            <th className='min-w-100px'>Break Time</th>
            <th className='min-w-140px'>Duration - Break</th>
            <th className='min-w-150px'>Language To</th>
            <th className='min-w-150px'>Communication Type</th>
            <th className='min-w-150px'>Appointment Status</th>
            <th className='min-w-120px'>Call Status</th>
            <th className='min-w-180px'>Meeting Summary Status</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={16}>
                <CommonLoading />
              </td>
            </tr>
          ) : data && data.length > 0 ? (
            data.map((item: any, index: number) => (
              <tr key={item?.code ?? index}>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.code ?? '-'}
                  </span>
                </td>
                <td>
                  {item.appointmentId && item.appointmentId !== 0 ? (
                    <a
                      href={`/appointmentViewer/${item.appointmentId}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-gray-800 text-hover-primary d-block fs-6'
                    >
                      {item.appointmentId}
                    </a>
                  ) : (
                    <span className='text-gray-800 d-block fs-6'>-</span>
                  )}
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.interpreter ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.customer ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.requester ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.date ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.startTime ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.endTime ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.totalDuration ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.breakTime ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.durationMinusBreak ?? item.totalDuration ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.languageTo ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.communicationType ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.appointmentStatus === 'Canceled' && item.cancelledStatus
                      ? `${item.appointmentStatus} | ${item.cancelledStatus}`
                      : item.appointmentStatus ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.callStatus ?? '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 d-block fs-6'>
                    {item.meetingSummaryStatus ?? '-'}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={14} className='text-center py-10'>
                <span className='text-muted fs-6'>No data available</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export { UninvoicedCallsTable }
